<button
  mat-button
  class="tw-text-sm tw-font-medium"
  matTooltipPosition="right"
  matTooltipClass="tw-text-sm tw-font-medium"
  [matTooltip]="_tooltipText || ''"
  [matTooltipDisabled]="!_tooltipText"
  [class.secondary]="menu.secondary"
  [disableRipple]="true"
  [disabled]="disabled">
  <ng-content></ng-content>
</button>

<ng-content select="[menu-item-content]"></ng-content>
